/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { AbstractRestService, RestSettings } from '@gh/core-data';
import { Observable } from 'rxjs';
import { SendToOfficeItemDto, SendToOfficeItemMapper } from './export-office.dto';

@Injectable()
export class ExportOfficeRestService extends AbstractRestService {

  constructor(settings: RestSettings) {
    super(settings);
  }

  sendToOffice(data: SendToOfficeItemDto): Observable<any> {
    return this.httpPut(`bulk-update/send-to-office`, data, SendToOfficeItemMapper);
  }
}
